module.exports = __webpack_public_path__ + "static/screen3-484fb0c8a5b53760919de5fbf7dc478e.png";